/* eslint-disable no-undef */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import KeyboardEventHandler from 'react-keyboard-event-handler';

class KeyHandler extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
    this.buffer = [];

    this.onKeyEvent = this.onKeyEvent.bind(this);
  }

  onKeyEvent(key) {
    if (key === 'clear') {
      this.buffer = [];
    } else if (key === 'ß' || key === '[') {
      this.buffer.push('-');
    } else if (key !== 'enter') {
      this.buffer.push(key);
    } else {
      const output = this.buffer.join('');
      this.buffer = [];
      this.props.onDidDetectWord(output);
    }
  }

  render() {
    return (
      <KeyboardEventHandler
        handleKeys={['all']}
        handleFocusableElements
        onKeyEvent={this.onKeyEvent}
      />
    );
  }
}

KeyHandler.propTypes = {
  onDidDetectWord: PropTypes.func.isRequired,
};

export default KeyHandler;
